export default __webpack_public_path__ + "static/media/7C2_E-8988.649f36ba.png";